window.wireWeights = {
    "Fine Silver - Wire - Round - Hard Temper" : {
        "0 Gauge / 8.25 mm": 170.918,
        "1 Gauge / 7.35 mm": 135.661,
        "2 Gauge / 6.54 mm": 107.408,
        "3 Gauge / 5.83 mm": 85.353,
        "4 Gauge / 5.19 mm": 67.642,
        "5 Gauge / 4.62 mm": 53.6,
        "6 Gauge / 4.12 mm": 42.626,
        "7 Gauge / 3.66 mm": 33.639,
        "8 Gauge / 3.26 mm": 26.688,
        "9 Gauge / 2.91 mm": 21.265,
        "10 Gauge / 2.59 mm": 16.845,
        "11 Gauge / 2.30 mm": 13.284,
        "12 Gauge / 2.05 mm": 10.553,
        "13 Gauge / 1.83 mm": 8.41,
        "14 Gauge / 1.63 mm": 6.672,
        "15 Gauge / 1.45 mm": 5.28,
        "16 Gauge / 1.29 mm": 4.179,
        "17 Gauge / 1.15 mm": 3.321,
        "18 Gauge / 1.02 mm": 2.613,
        "19 Gauge / 0.91 mm": 2.08,
        "20 Gauge / 0.81 mm": 1.648,
        "21 Gauge / 0.72 mm": 1.302,
        "22 Gauge / 0.64 mm": 1.029,
        "23 Gauge / 0.57 mm": 0.816,
        "24 Gauge / 0.51 mm": 0.653,
        "25 Gauge / 0.45 mm": 0.509,
        "26 Gauge / 0.4 mm": 0.402,
        "27 Gauge / 0.36 mm": 0.325,
        "28 Gauge / 0.32 mm": 0.257,
        "29 Gauge / 0.29 mm": 0.211,
        "30 Gauge / 0.25 mm": 0.157
    }
    }